/**
 * Pinia Store Plugin Configuration
 */
import { createPinia } from 'pinia';
import type { App } from 'vue';
import { createPersistedState } from './pinia-persist';

export function setupPinia(app: App) {
  const pinia = createPinia();

  // Add persistence plugin
  pinia.use(createPersistedState());

  app.use(pinia);

  // Enable HMR in development
  if (import.meta.hot) {
    import.meta.hot.accept();
  }

  return pinia;
}
